import "../scss/page.scss";

import "../scss/forwhom.scss";

import "./scripts/slick/forwhom.js";
import "./scripts/global/faq.js";